import React from "react";

class Footer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {  
    return (
      <footer id="footer" style={{ clear: "both" }}>
        <p id="copyright">&copy;2019-2026 okbmsyk.</p>
      </footer>
    );
  };
}

export default Footer;